import type { ConstValues } from '../helpers.ts';

export const UrlTargetingType = {
  blacklist: 'blacklist',
  whitelist: 'whitelist',
} as const;
export type UrlTargetingType = ConstValues<typeof UrlTargetingType>;

export const DomainTargeting = {
  ALL_VARIATIONS: 'SUBDOMAIN',
  NO_SUBDOMAINS: 'ROOT',
} as const;
export type DomainTargetingType = ConstValues<typeof DomainTargeting>;

export const DomainAppInventoryOperator = {
  OR: 'OR',
  AND: 'AND',
} as const;
export type DomainAppInventoryOperator = ConstValues<typeof DomainAppInventoryOperator>;

export const UrlTargetingFields = {
  type: 'type',
  urls: 'urls',
  inventorylist_id: 'inventorylist_id',
  domain_targeting_option: 'domain_targeting_option',
  domain_app_inventory_operator: 'domain_app_inventory_operator',
} as const;

export type UrlTargeting = {
  [UrlTargetingFields.type]: UrlTargetingType;
  [UrlTargetingFields.urls]?: string[] | null;
  [UrlTargetingFields.inventorylist_id]?: string | null;
  [UrlTargetingFields.domain_targeting_option]: DomainTargetingType;
  [UrlTargetingFields.domain_app_inventory_operator]?: DomainAppInventoryOperator | null;
};
